export function OutlineUserComercialIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0165 10.9968C14.2247 10.9968 16.0149 9.20667 16.0149 6.99841C16.0149 4.79015 14.2247 3 12.0165 3C9.80821 3 8.01807 4.79015 8.01807 6.99841C8.01807 9.20667 9.80821 10.9968 12.0165 10.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.01145 14.002H18.0163C19.1203 14.002 20.0131 14.8948 20.0131 15.9988V21.0004H4.01465V15.9988C4.01465 14.8948 4.90745 14.002 6.01145 14.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0132 21.0004L17.0148 14.002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.01479 21.0004L7.01318 14.002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 18L12.0164 14.002L12.5 18L12 19L11.5 18Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
